/**
 * ============================================================
 * JDL — Guide des tailles : liens d'ouverture + « Choisir la taille X »
 * (21/10/2026)
 * ------------------------------------------------------------
 * 1. Tout élément [data-jdl-sg-open] ouvre le tiroir du guide
 *    (ex. lien « Guide des tailles » sur la ligne « Taille »).
 *    Écoute déléguée : marche même après les re-rendus Dawn.
 * 2. Quand le recommandeur trouve une taille, le bouton
 *    « Choisir la taille X » apparaît (si la taille existe sur la fiche).
 *    Un clic coche la taille dans le sélecteur et ferme le tiroir.
 *
 * Dépend de snippets/size-guide-drawer.liquid (window.jdlSizeGuide,
 * #jdl-sg-apply) et de l'attribut data-jdl-size-option posé dans
 * snippets/product-variant-picker.liquid.
 *
 * RGPD : la taille et le poids saisis restent dans la page, ne sont
 * ni envoyés, ni stockés, ni transmis à Clarity.
 * ============================================================
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api; // tests Node
  else api.boot(window, document);
})(this, function () {
  'use strict';

  /** Normalise une taille : « xxl » et « 2XL » sont la même taille. */
  function normalizeSize(value) {
    var v = String(value == null ? '' : value).trim().toUpperCase().replace(/\s+/g, '');
    var aliases = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' };
    return aliases[v] || v;
  }

  /**
   * Trouve, parmi les tailles proposées sur la fiche, celle qui correspond
   * à la recommandation. Fonction pure (testée).
   * @param {string|null} recommended taille recommandée (ex. « 2XL », « 8-10 »)
   * @param {string[]} values valeurs des boutons de taille de la fiche
   * @returns {string|null} la valeur exacte du bouton, ou null
   */
  function matchSizeValue(recommended, values) {
    if (!recommended || !values) return null;
    var target = normalizeSize(recommended);
    for (var i = 0; i < values.length; i++) {
      if (normalizeSize(values[i]) === target) return values[i];
    }
    return null;
  }

  /** Bloc produit principal (les fenêtres « Choisir des options » portent data-update-url="false"). */
  function mainProductInfo(doc) {
    return doc.querySelector('product-info[data-update-url="true"]') || doc.querySelector('product-info');
  }

  /** Boutons radio de la rangée « Taille » du bloc principal. */
  function sizeInputs(doc) {
    var pi = mainProductInfo(doc);
    if (!pi) return [];
    return Array.prototype.slice.call(pi.querySelectorAll('[data-jdl-size-option] input[type="radio"]'));
  }

  function boot(win, doc) {
    if (win.__jdlSizeGuide) return; // fichier potentiellement réinjecté
    win.__jdlSizeGuide = true;

    /** Met à jour le bouton « Choisir la taille X » (appelé par le recommandeur). */
    function update(recommended) {
      var btn = doc.getElementById('jdl-sg-apply');
      if (!btn) return;
      var values = sizeInputs(doc).map(function (i) { return i.value; });
      var match = matchSizeValue(recommended, values);
      btn.hidden = !match;
      btn.dataset.size = match || '';
      var label = doc.getElementById('jdl-sg-apply-size');
      if (label) label.textContent = match || '';
    }
    win.jdlSizeGuideApply = { update: update };

    doc.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      // 1. Ouverture du tiroir depuis un lien [data-jdl-sg-open]
      if (e.target.closest('[data-jdl-sg-open]')) {
        e.preventDefault();
        if (win.jdlSizeGuide) win.jdlSizeGuide.open();
        return;
      }

      // 2. « Choisir la taille X »
      var apply = e.target.closest('#jdl-sg-apply');
      if (!apply || !apply.dataset.size) return;
      var input = sizeInputs(doc).filter(function (i) { return i.value === apply.dataset.size; })[0];
      if (win.jdlSizeGuide) win.jdlSizeGuide.close();
      // .click() sur le bouton radio déclenche le flux Dawn normal (prix, stock, URL).
      if (input && !input.checked) input.click();
    });
  }

  return { normalizeSize: normalizeSize, matchSizeValue: matchSizeValue, boot: boot };
});
